module.exports = __webpack_public_path__ + "img/process-3.506a6943.png";